import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { confirmAlert } from 'react-confirm-alert';
import './RegistrationCodePanel.scss';

import { rotateBrandRegistrationCode } from '../../../../Actions/BrandActions';
import { rotateManagerRegistrationCode } from '../../../../Actions/ManagerActions';
import { getBrandRegistrationCode, isBrand, getRegistrationCode } from '../../../../Helpers/user_helpers';

import { getBrand } from '../../../../Helpers/user_helpers';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/pro-light-svg-icons';

const RegistrationCodePanel = props => {
  const { user } = props;
  const registrationCode = isBrand(user) ? getBrandRegistrationCode(user)?.code : getRegistrationCode(user);

  const [isLoading, setIsLoading] = useState(false);
  const [registrationCodeIsVisible, setRegistrationCodeIsVisible] = useState(false);

  const rotateManagerRegistrationCode = () => {
    if (isLoading) return window.ALERT.error('Please wait for the current operation to complete.');
    setIsLoading(true);

    confirmAlert({
      title: 'Are you sure you want to rotate your registration code?',
      message: (
        <>
          Your current registration code will be replaced and all creators that try to use the old registration code will be blocked.
          <br />
          <b>This cannot be undone.</b>
        </>
      ),
      buttons: [
        {
          label: 'Rotate registration code',
          className: 'danger',
          onClick: async () => {
            const res = await props.rotateManagerRegistrationCode();

            if (res.error) window.ALERT.error(res.error || 'There was an error rotating your registration code, please try again.');
            else window.ALERT.success('Rotated ShopMy registration code!');
            setIsLoading(false);
          }
        },
        { label: 'Cancel', onClick: () => setIsLoading(false), className: 'cancel' }
      ]
    });
  };

  const rotateBrandRegistrationCode = () => {
    if (isLoading) return window.ALERT.error('Please wait for the current operation to complete.');
    setIsLoading(true);

    confirmAlert({
      title: 'Are you sure you want to rotate your registration code?',
      message: (
        <>
          Your current registration code will be replaced and all creators that try to use the old registration code will be blocked.
          <br />
          <b>This cannot be undone.</b>
        </>
      ),
      buttons: [
        {
          label: 'Rotate registration code',
          className: 'danger',
          onClick: async () => {
            const res = await props.rotateBrandRegistrationCode(getBrand(props.user)?.id);

            if (res.error) window.ALERT.error(res.error || 'There was an error rotating your registration code, please try again.');
            else window.ALERT.success('Rotated ShopMy registration code!');
            setIsLoading(false);
          }
        },
        { label: 'Cancel', onClick: () => setIsLoading(false), className: 'cancel' }
      ]
    });
  };

  return (
    <div className='registration-code-panel-outer'>
      <div className='registration-code-panel-inner'>
        <div className='settings-section'>
          <div className='settings-section-title'>Registration Code</div>
          <div className='settings-section-subtitle'>
            Creators will use this code to bypass our vetting process and waitlist. They will sign up directly as a creator and show up in your talent
            dashboard.
          </div>
          <div className='settings-section-split-input'>
            <div className='settings-section-split-input-password'>
              <input
                className='settings-input'
                type={registrationCodeIsVisible || !registrationCode?.code ? 'text' : 'password'}
                placeholder='•••••••••••••••••••••••'
                value={registrationCode ? registrationCode.code : 'You have no registration code, please rotate to create one.'}
                disabled
              />
              {!!registrationCode?.code && (
                <FontAwesomeIcon
                  icon={registrationCodeIsVisible ? faEye : faEyeSlash}
                  className='password-view-icon'
                  onClick={() => setRegistrationCodeIsVisible(!registrationCodeIsVisible)}
                />
              )}
            </div>
            <button
              className='settings-button dark'
              onClick={isBrand(user) ? rotateBrandRegistrationCode : rotateManagerRegistrationCode}
              disabled={isLoading}
            >
              Rotate
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

RegistrationCodePanel.propTypes = {
  user: PropTypes.object.isRequired,
  rotateBrandRegistrationCode: PropTypes.func.isRequired,
  rotateManagerRegistrationCode: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const { user } = state;
  return { user };
};

export default connect(mapStateToProps, {
  rotateBrandRegistrationCode,
  rotateManagerRegistrationCode
})(withRouter(RegistrationCodePanel));
